/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {FacilitatorRegistration} from './components/FacilitatorRegistration'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

const AuthLayout = () => { 
  useEffect(() => {
    document.body.classList.add('bg_remove')
    return () => {
      document.body.classList.remove('bg_remove')
    }
  }, [])
  // useEffect(() => {
  //   document.body.classList.add('bg-white')
  //   return () => {
  //     document.body.classList.remove('bg-white')
  //   }
  // }, [])
  
  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed '
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/auth-background.png') })` ,
        backgroundSize: 'cover',
      }}
    >
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10'>
        {/* begin::Logo */}
        {/* <a href='#' className='mb-12'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo.png')} className='h-45px' />
        </a> */}
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='w-lg-500px bg-custom-pink rounded shadow-sm p-10 mx-auto'>
          <Outlet />
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
      {/* begin::Footer */}
      <div className='d-flex flex-center flex-column-auto p-2 footer'>
        <div className='d-flex align-items-center fw-bold fs-6'>
          <a href='#' className='text-muted p-2'>
            About
          </a>

          <a href='#' className='text-muted p-2'>
            Contact
          </a>

          <a href='#' className='text-muted p-2'>
            Contact Us
          </a>
        </div>
      </div>
      {/* end::Footer */}
      
    </div>
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='registration' element={<Registration />} />
      <Route path='facilitator-registration' element={<FacilitatorRegistration />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)


export {AuthPage}
